import styled from 'styled-components'

import bgImage from '../../images/sales-training-form-bg.png'
import { rspTheme } from '../../styles/rspTheme'

const tabletBreakpoint = rspTheme.breakpoints.values.md

export const StepFormSection = styled.section`
  background-image: url(${bgImage}),
    linear-gradient(
      90deg,
      rgba(79, 114, 136, 1) 0%,
      rgba(107, 166, 173, 1) 34%,
      rgba(107, 166, 172, 1) 100%
    );
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;

  padding: 40px 0 40px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 10;
  color: ${rspTheme.palette.primary.main};
  margin-top: 40px;

  @media (max-width: ${tabletBreakpoint}px) {
    margin-top: 28px;
    padding: 0 0 40px;

    .carousel-root {
      margin: auto -16px;
    }
  }

  .slide {
    padding: 0 0 28px;
    display: flex;
    align-items: stretch;

    @media (max-width: ${tabletBreakpoint}px) {
      padding: 28px 28px;
    }
  }
`

export const CenterContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 800px;
  margin: 0 auto;
`

export const Column = styled.div`
  width: calc(50% - 10px);
  display: flex;
  flex-direction: column;

  + .column {
    margin-left: 20px;
  }

  @media (max-width: ${tabletBreakpoint}px) {
    width: 100%;
    + .column {
      margin-left: 0;
    }
  }
`
export const DotContainer = styled.div`
  margin: 12px auto 0;
  max-width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    flex-shrink: 0;
  }
`

interface IndicatorDotProps {
  active: boolean
}

export const IndicatorDot = styled.div<IndicatorDotProps>`
  width: 18px;
  height: 18px;
  background-color: ${({ active }) => (active ? '#ffffff' : '#1F1749')};
  border-radius: 50%;
  transition: background-color 0.2s ease-in-out;
  position: relative;

  + .indicatorDot {
    margin-left: 16px;
  }
`
